import CommonShare from '@xfe/common-share';
import didMount from '@src/components/hoc/did-mount';
import { validIpAddressRegex } from '@src/constants/regex';
import { isIOS, isWeiXin } from 'detect-mobile-device';
import reload from '../../utils/reload';

const commonShare = new CommonShare({
  commonSdkUrl: '//zhcdn01.xoyo.com/xassets/lib/qq-wx-share/1.6.0/share.min.js'
});

/**
 * 自定义微信分享
 * @param shareParams
 * @param disableReplaceAutoAddQs
 *
 * 替换微信自动添加的qs
 *
 * 参考：https://segmentfault.com/a/1190000014461916

 * 1、分享出去的外链的域名必须和公众号后台配置的JS安全域名一致，否则会导致分享的失败
 * 2、分享出去的外链，会自动给加上微信标识，导致二次分享失败。
 *
 * 微信自动在分享后边加上了query字符串：
 * from=groupmessage   分享到群
 * from=timeline  分享到朋友圈
 * from=singlemessage  分享到好友
 * isappinstalled=0    0或1，表示是否安装了app
 * 安卓手机分享到朋友圈的链接，只会带from=timeline。
 *
 *
 * @param disableValidateShareParams
 * 是否禁止校验分享参数,
 * 目前分享参数自动会进行校验合法性
 *
 */
export function share(shareParams, { disableReplaceAutoAddQs, disableValidateShareParams } = {}) {
  const { hostname } = window.location;
  if (DEPLOY_ENV && hostname !== 'localhost' && !validIpAddressRegex.test(hostname)) {
    isWeiXin() && isIOS() && iosRefresh();
    commonShare.run(shareParams, { disableReplaceAutoAddQs, disableValidateShareParams });
  } else {
    console.warn('分享仅在代理host、测试或正式环境生效');
  }
}

/**
 * ios微信分享时执行页面刷新,用于解决ios二次分享失败问题
 */
function iosRefresh() {
  if (!sessionStorage['IOS_REFRESH']) {
    sessionStorage['IOS_REFRESH'] = 1;
    reload();
  }
}

/**
 * shareParams - 分享参数, 如:
 * @example
 * @wxShare({
 *  title: '剑侠世界手游，关注赢取小米MIX',
 *  $link: window.location.href,
 *  imgUrl: 'http://js.xoyo.com/zt/2016/10/operate/share.jpg',
 *  desc: '剑侠世界手游版 - 一生不可错过的浪漫武侠',
 *  swapTitleInWX: true
 * })
 * export default XXX extends React.Component...
 */
const qqwxShare = didMount(share);

export default qqwxShare;
